import type { ReactNode } from "react";

import { cn } from "../../ui/cn";

/** The muted line under a title or beside a control. */
export function Muted({
  children,
  className,
}: Readonly<{ children: ReactNode; className?: string }>) {
  return <span className={cn("text-sm text-muted-foreground", className)}>{children}</span>;
}
